'use strict';

const _=require('pulsar-utils/dist-es6/_');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const AlertStatusCache=require('../../../dist-es6/client/viewModels/alertStatusCache');let

GroupStatisticsViewModel=class GroupStatisticsViewModel{
constructor(
id,
name,
aggregatePersons,
directPersons,
numTripsOnDuty,
numPersonsOnDuty,
maxFatigueOnDuty,
maxLastKnownFatigue,
averageHoursOfSleepPerDay,
averageFatigueOnDuty,
fatigueThreshold,
deviationThreshold,
percentOverThresholdCache=void 0,
isSpecialGroupContainingWholeOrg=!1){

_.ensureInstanceOf('number',fatigueThreshold);
_.ensureInstanceOf('number',deviationThreshold);
if(deviationThreshold<1||deviationThreshold>3){
throw new Error(`Unexpected deviationThreshold: ${deviationThreshold}`);
}

this._id=id;
this._name=name;
this._aggregatePersons=aggregatePersons;
this._directPersons=directPersons;
this._numTripsOnDuty=numTripsOnDuty;
this._numPersonsOnDuty=numPersonsOnDuty;
this._maxFatigueOnDuty=maxFatigueOnDuty;
this._maxLastKnownFatigue=maxLastKnownFatigue;
this._averageHoursOfSleepPerDay=averageHoursOfSleepPerDay;
this._averageFatigueOnDuty=averageFatigueOnDuty;
this._fatigueThreshold=fatigueThreshold;
this._deviationThreshold=deviationThreshold;
this._isSpecialGroupContainingWholeOrg=isSpecialGroupContainingWholeOrg;

if(this._isSpecialGroupContainingWholeOrg){
this.children=[];
}

this._percentOverThresholdCache=percentOverThresholdCache||new AlertStatusCache(nt=>this._percentOverThreshold(nt));
}

get id(){
return this._id;
}

get name(){
return this._name;
}

get aggregatePersons(){
return this._aggregatePersons;
}

get directPersons(){
return this._directPersons;
}

get numTripsOnDuty(){
return this._numTripsOnDuty;
}

get numPersonsOnDuty(){
return this._numPersonsOnDuty;
}

get maxFatigueOnDuty(){
return this._maxFatigueOnDuty;
}

get maxLastKnownFatigue(){

return this._maxLastKnownFatigue;
}

get maxFatigueForHeader(){
return this._maxFatigueForHeader;
}

set maxFatigueForHeader(maxFatigueForHeader){
this._maxFatigueForHeader=maxFatigueForHeader;
}

get averageHoursOfSleepPerDay(){
return this._averageHoursOfSleepPerDay;
}

get averageFatigueOnDuty(){
return this._averageFatigueOnDuty;
}

set children(children){
if(_.exists(this._children)){
throw new Error('children can only be set once');
}
_.ensureInstanceOf(Array,children);
children.forEach(c=>_.ensureInstanceOf(GroupStatisticsViewModel,c));

this._children=children;
}

get children(){
return this._children;
}

get isSpecialGroupContainingWholeOrg(){
return this._isSpecialGroupContainingWholeOrg;
}

get fatigueThreshold(){
return this._fatigueThreshold;
}

get deviationThreshold(){
return this._deviationThreshold;
}

percentOverThreshold(notificationType){
return this._percentOverThresholdCache.get(notificationType);
}

_hasPersonOverThreshold(notificationType){
return this.aggregatePersons.
some(person=>_.get(person,'currentStatus.onDuty')===!0&&
person.thresholdStatusFor(notificationType)===ThresholdStatus.Above);
}

_hasPersonAtThreshold(notificationType){
return this.aggregatePersons.
some(person=>_.get(person,'currentStatus.onDuty')===!0&&
person.thresholdStatusFor(notificationType)===ThresholdStatus.At);
}

_percentOverThreshold(notificationType){
_.ensureInstanceOf(NotificationType,notificationType);

const numAggregatePersons=this.aggregatePersons.length;
if(numAggregatePersons===0){
return'--';
}

const numOverThreshold=this.aggregatePersons.
filter(person=>person.thresholdStatusFor(notificationType)===ThresholdStatus.Above).
length;

return`${Math.ceil(numOverThreshold/numAggregatePersons*100)}%`;
}

removePersonsNotMatching(predicate){

this._aggregatePersons=this._aggregatePersons.filter(predicate);
this._directPersons=this._directPersons.filter(predicate);
}};


module.exports=GroupStatisticsViewModel;
//# sourceMappingURL=groupStatisticsViewModel.js.map
